import { Link } from "react-router-dom";

export default function Logo({ dark = false, showText = true }) {
  return (
    <Link to="/" className="flex items-center gap-3 group" data-testid="brand-logo">
      <img
        src="/has_logo.png"
        alt="Horizon Affaires Senegal"
        className="h-10 w-10 object-contain transition-transform duration-300 group-hover:scale-105"
      />
      {showText && (
        <div className="leading-none">
          <div className={`font-display text-[15px] font-semibold tracking-tight ${dark ? "text-white" : "text-slate-900"}`}>
            Horizon Affaires
          </div>
          <div className="text-[11px] tracking-[0.2em] text-sky-500 font-medium uppercase">Senegal</div>
        </div>
      )}
    </Link>
  );
}
